import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const locationsSliders = document.querySelectorAll('.swiper-locations');

locationsSliders.forEach((slider) => {
    new Swiper(slider, {
        modules: [Navigation, Pagination],
        loop: false,
        centeredSlides: true,
        slidesPerView: 1.2,
        spaceBetween: 50,
        navigation: {
            nextEl: slider.querySelector('[class*="swiper-button-next-"]'),
            prevEl: slider.querySelector('[class*="swiper-button-prev-"]'),
        },
        pagination: {
            el: slider.querySelector('[class*="swiper-pagination-"]'),
            clickable: true,
        },

        breakpoints: {
            640: {
                spaceBetween: 10,
            },
            768: {
                spaceBetween: 50,
            },

        },
    });
});
